<template>
    <div>
        <base-map-marker :lat-lng="[location.lat, location.lng]" :point="point" :isMeta="isMeta"
            :disabled="!isSelectedClassificationMarker">
            <!-- Point icons. -->
            <template v-slot:icon>
                <template v-for="(type, typeName) in types">
                    <div v-if="hasType(type)" :key="type" :class="{
                        icon: true,
                        [`icon--${typeName}`]: true,
                        disabled:
                            hasType(type) &&
                            !hasSelectedClassification(type),
                    }" />
                </template>
                <div :class="pointerClasses" />
            </template>
        </base-map-marker>
    </div>
</template>

<script>
import BaseMapMarker from '@/components/BaseMapMarker'
import { TRACKPOINT_TYPES } from '@/config'
import { mapGetters } from 'vuex'
export default {
    components: {
        BaseMapMarker,
    },

    props: {
        point: {
            type: Object,
            required: true,
        },
        classifications: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            types: TRACKPOINT_TYPES,
        }
    },
    computed: {
        ...mapGetters(['trackpoints', 'locations', 'selectedClassificationId']),
        trackpointsIds() {
            return Object.values(this.point.trackpoints)
        },
        location() {
            return this.locations[this.point.location]
        },
        isMeta() {
            const trackpointsTypes = []
            for (const id of this.trackpointsIds) {
                trackpointsTypes.push(this.trackpoints[id].type)
            }
            return (
                trackpointsTypes.includes(this.types.meta) &&
                this.trackpoints[
                    this.point.trackpoints?.MET
                ].classifications.includes(this.selectedClassificationId)
            )
        },
        pointerClasses() {
            return {
                marker__pointer: true,
                'marker__pointer--disabled': !this
                    .isSelectedClassificationMarker,
                'marker__pointer--red':
                    this.isMeta && this.isSelectedClassificationMarker,
            }
        },
        isSelectedClassificationMarker() {
            const trackpoints = []
            for (const id of this.trackpointsIds) {
                trackpoints.push(this.trackpoints[id])
            }
            const trackpointsClassifications = new Set()
            for (const track of trackpoints) {
                for (const classification of track.classifications) {
                    trackpointsClassifications.add(classification)
                }
            }
            return trackpointsClassifications.has(this.selectedClassificationId)
        },
    },
    methods: {
        hasType(type) {
            return this.point.trackpoints[type] !== undefined
        },
        hasSelectedClassification(type) {
            const trackpointId = this.point.trackpoints[type]
            const trackpoint = this.trackpoints[trackpointId]
            if (this.selectedClassificationId) {
                return trackpoint.classifications.includes(
                    this.selectedClassificationId
                )
            }
            return (
                trackpoint.classifications.length ===
                this.classifications.length
            )
        },
    },
}
</script>

<style lang="scss" scoped>
.disabled {
    opacity: 0.5;
}

%default-icon {
    font-family: 'Font Awesome 5 Free';
    font-size: 18px;
    font-weight: 900;
    color: $white;
}

.icon {
    height: 32px;
    width: 32px;
    display: flex;
    justify-content: center;
    align-items: center;

    &--meta::before {
        @extend %default-icon;
        content: '\f11e';
    }

    &--start::before {
        @extend %default-icon;
        content: '\f3c5';
    }

    &--checkpoint::before {
        @extend %default-icon;
        content: '\f2f2';
    }

    &--buffet::before {
        @extend %default-icon;
        content: '\f2e7';
    }

    &--return::before {
        @extend %default-icon;
        content: '\f0e2';
    }
    &--change::before {
        @extend %default-icon;
        content: '\f362';
    }
    &--fans::before {
        @extend %default-icon;
        content: '\f0c0';
    }
    &--office::before {
        @extend %default-icon;
        content: '\f2c2';
    }
    &--parking::before {
        @extend %default-icon;
        content: '\f540';
    }
}

.marker__pointer {
    position: absolute;
    top: 98%;
    left: 12px;
    mask: url('../assets/images/pointer-black.svg');
    height: 8px;
    width: 16px;
    background: $slate-two;

    &--red {
        background-image: linear-gradient(to left,
                $red-orange 100%,
                $pinky-red 1%);
    }

    &--disabled {
        background: $bluish-grey;
    }
}
</style>
